import React from 'react'
import CatalogueList from '../finwhale/common/catalogue-list'
import TranslateText from 'src/text/modal';
import styled from 'styled-components'
import * as media from '../media'

const Container = styled.div`
  width: 80%;
  margin: 0 auto;
  font-size: 18px;
  ${media.smallerThan(600)`width: 100%; padding-left: 10px; padding-right: 10px;`}
`

const production = () => (
  <div>
    <Container>
      <p style={{margin: '40px auto', fontSize: 24, fontWeight: 800,}}>
        <TranslateText id="catalogue__title"/>
      </p>
      <CatalogueList/>
    </Container>
  </div>
)

export default production



// WEBPACK FOOTER //
// ./src/pages/production.js